export default __webpack_public_path__ + "static/media/ic_punchcard.77fc074cecf9663374c8210266c112cc.svg";